module.exports = __webpack_public_path__ + "static/img/00011B_X_3_4_5_20170731_LC.77ec048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00011B_X_3_4_5_20170731_LC.png
// module id = 9yAw
// module chunks = 0